export default function getInitialsName(name?: string): string {
  if (!name || typeof name !== 'string') return '';
  return name?.replace(/[a-z 0-9]/g, '')?.slice(0, 2);
}
